import React, { Component } from "react";
import "./App.css";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import { fetchConfigDetailsFromClientHost } from "./Simplify360Chat/Services/HWIframeBridge";
import Simplify360Tatasky from "./Simplify360Tatasky/Simplify360Tatasky";

class App extends Component {
  constructor(props) {
    super(props);
    s360ConfigService.loadClientConfigFromToken();

    let configEncodedString = (window.location.pathname || "").substring(
      1,
      (window.location.pathname || "").length
    );

    const decodedString =
      s360ConfigService.decodeConfigToken(configEncodedString);

    // console.log("LOG1", decodedString, decodedString.userDetails);

    this.state = {
      subscriberId:
        decodedString != null
          ? decodedString.subscriberId
          : s360ConfigService.getConfig.subscriberId,
      authenticated:
        decodedString != null
          ? decodedString.authenticated
          : s360ConfigService.getConfig.authenticated,
      viewType: s360ConfigService.getConfig.viewType,
      sessionId: s360ConfigService.config.sessionId,
      source: s360ConfigService.config.source,
      inputbox: s360ConfigService.config.inputbox,
      action: decodedString != null ? decodedString.action : null,
      src: decodedString != null ? decodedString.src : null,
      hideLoading: false,
      launchOnButton: decodedString != null ? decodedString.hideLoading : null,
      loginCount: 0,
      openChat: decodedString != null ? decodedString.openChat : null,
      userDetails: decodedString?.userDetails,
    };
  }

  componentDidMount() {
    fetchConfigDetailsFromClientHost();
    // window.addEventListener("resize", reportWindowSize());
  }

  render() {
    return (
      <div className="App">
        <Simplify360Tatasky
          subscriberId={this.state.subscriberId}
          inputbox={this.state.inputbox}
          authenticated={this.state.authenticated}
          viewType={this.state.viewType}
          sessionId={this.state.sessionId}
          source={this.state.source}
          action={this.state.action}
          hideLoading={this.state.hideLoading}
          launchOnButton={this.state.launchOnButton}
          loginCount={this.state.loginCount}
          openChat={this.state.openChat}
          src={this.state.src}
          userDetails={this?.state?.userDetails}
        />
      </div>
    );
  }
}

const reportWindowSize = () => {
  let chatFrame = document.getElementById("top");

  const zoomlevel = Math.round(window.devicePixelRatio * 100);

  console.log("zoomlevel", zoomlevel, window.innerWidth, window.innerHeight);

  if (chatFrame) {
    if (window.innerWidth <= 900) {
      chatFrame.style =
        "position: fixed; width:100vw !important; height:100% !important;max-height:100%;right:0px;bottom: 0px;overflow: hidden;";
    } else {
      chatFrame.style =
        "position: fixed; width:400px; height:530px;max-height:100%;right:20px;bottom: 20px;overflow: hidden; box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;";
    }
    if (window.innerHeight < 650 && window.innerWidth > 450) {
      if (zoomlevel > 250) {
        chatFrame.style =
          "position: fixed; width:200px; height:200px;max-height:90%;right:-3%;bottom: -5%;overflow: hidden; scale:0.83;";
      } else {
        chatFrame.style =
          "position: fixed; width:393px; height:550px;max-height:90%;right:-3%;bottom: -5%;overflow: hidden; scale:0.83;";
      }
    }
    if (window.innerHeight < 650 && window.innerWidth < 450) {
      chatFrame.style =
        "position: fixed; width:100%; height:100%;max-height:100%;right:0;bottom:0;overflow: hidden;";
    }
  }
};

export default App;
